import {
  Dialog,
  DialogActions,
  DialogContentText,
  DialogProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import styled from '@emotion/styled';
import { PmiDialogContent } from 'shell/components/shared/dialog/content';

const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

export interface AnnotationFormVM {
  annotation: string;
  note: string;
}

interface ModalDomesticPartnershipProps {
  open: boolean;
  onOkClose: () => void;
  onCancel: () => void;
}

const ModalDomesticPartnershipComponent = ({
  open,
  onOkClose, // OK
  onCancel, // KO
}: ModalDomesticPartnershipProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      fullScreen={fullScreen}
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="cdmBrand" color="white">
        Attenzione
      </PmiDialogTitle>
      <PmiDialogContent style={{ padding: '30px 24px' }}>
        <DialogContentText id="alert-dialog-content">
          Attenzione verificare che il grado di parentela della persona selezionata sia compaibile
          con la famiglia aggegante
        </DialogContentText>
      </PmiDialogContent>
      <DialogActions>
        <PmiButton variant="outlined" color="cdmBrand" onClick={onCancel}>
          Chiudi
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrandThird" onClick={onOkClose}>
          Conferma
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalDomesticPartnershipComponent.displayName = 'Modal Domestic Partnership component';

const ModalDomesticPartnership = memo(ModalDomesticPartnershipComponent);

export default ModalDomesticPartnership;
